import React from "react";
import { useI18n } from "../../i18n/I18nContext";
import { Gift, CreditCard } from "lucide-react";

export default function Gifts() {
  const { t, isAr } = useI18n();
  const cards = [
    [Gift, isAr ? "باقة هدية" : "Gift Package", isAr ? "أهدِ جلسة تصوير عبر رابط أو كود" : "Gift a session via link or code"],
    [CreditCard, isAr ? "بطاقة هدية" : "Gift Card", isAr ? "بطاقة بقيمة مالية قابلة للاستخدام الجزئي" : "Monetary card with partial redemption"],
  ];
  return (
    <div className="mx-auto max-w-4xl px-4 py-12 sm:px-8">
      <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t("nav.gifts")}</h1>
      <div className="mt-8 grid grid-cols-1 gap-6 sm:grid-cols-2">
        {cards.map(([Icon, title, desc], i) => (
          <div key={i} className="rounded-3xl border border-border bg-white p-8 text-center transition-all hover:shadow-lg">
            <div className="mx-auto mb-4 inline-flex h-14 w-14 items-center justify-center rounded-2xl bg-[hsl(var(--brand-orange))]/10 text-[hsl(var(--brand-orange))]"><Icon className="h-7 w-7" /></div>
            <h3 className="text-lg font-bold text-slate-900">{title}</h3>
            <p className="mt-2 text-sm text-slate-500">{desc}</p>
          </div>
        ))}
      </div>
      <p className="mt-6 text-center text-xs text-amber-600">{isAr ? "شراء الهدايا يتطلب تفعيل بوابة الدفع (وضع تجريبي حالياً)" : "Gift purchase requires an active payment gateway (demo mode)"}</p>
    </div>
  );
}
